/**
 * Utilitários para geração de URLs de webhook no frontend
 */

/**
 * Gera a URL do webhook baseada no target_db_name do usuário
 * @param {string} targetDbName - Nome do schema/banco do usuário
 * @param {Object} req - Objeto de requisição (opcional, para compatibilidade)
 * @returns {string} URL do webhook
 */
export function generateWebhookUrl(targetDbName, req = null) {
  // Se target_db_name não foi fornecido, usar URL padrão do .env como fallback
  if (!targetDbName) {
    // Priorizar REACT_APP_WEBHOOK_URL do .env se definido
    if (process.env.REACT_APP_WEBHOOK_URL) {
      return process.env.REACT_APP_WEBHOOK_URL;
    }

    // Verificar se estamos em produção
    if (process.env.NODE_ENV === 'production') {
      return 'https://papia.aytech.online/api/evolution/webhook/evolution';
    }

    // Desenvolvimento: verificar se há ngrok configurado
    if (process.env.REACT_APP_NGROK_URL) {
      return `${process.env.REACT_APP_NGROK_URL}/api/evolution/webhook/evolution`;
    }

    // Fallback para desenvolvimento local
    return 'http://localhost:3001/api/evolution/webhook/evolution';
  }

  // Gerar URL específica para o usuário baseada no target_db_name
  const base = process.env.REACT_APP_N8N_BASE_URL || 'https://devn8n.aytech.online';
  const cleanBase = String(base).replace(/\/$/, '');
  return `${cleanBase}/webhook/${String(targetDbName).replace(/^\//, '')}`;
}